const findNext = <T>(
    array: T[],
    startIndex: number,
    condition: (val: T) => boolean,
    direction: number = 1
) => {
    const length = array.length

    // Search through entire array, wrapping around
    for (let count = 0; count < length; count++) {
        const rawI = (startIndex + direction * (count + 1) + length) % length
        const i = Math.max(rawI, 0)
        if (condition(array[i])) {
            return array[i]
        }
    }
    return undefined
}

export { findNext }
